"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Code = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var react_syntax_highlighter_1 = require("react-syntax-highlighter");

var prism_1 = require("react-syntax-highlighter/dist/esm/styles/prism");

var styled_1 = __importDefault(require("@emotion/styled"));

var Code = function Code(_ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "inherit" : _ref$size,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? "typescript" : _ref$language,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? "primary" : _ref$background,
      className = _ref.className,
      dataTestId = _ref.dataTestId;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var backgroundColor = "";
  var fontSize = "";
  var fontLineHeight = "";
  var mobileFontSize = "";
  var mobileLineHeight = "";

  switch (theme.colors[background].background) {
    case theme.colors.primary.lighterGray:
      backgroundColor = theme.colors.primary.white;
      break;

    default:
      backgroundColor = theme.colors.primary.lighterGray;
  }

  switch (size) {
    case "xl":
      fontSize = theme.typography.fonts.sizes.xl.size;
      fontLineHeight = theme.typography.fonts.sizes.xl.lineHeight;
      mobileFontSize = theme.typography.fonts.sizes.lg.size;
      mobileLineHeight = theme.typography.fonts.sizes.lg.lineHeight;
      break;

    case "lg":
      fontSize = theme.typography.fonts.sizes.lg.size;
      fontLineHeight = theme.typography.fonts.sizes.lg.lineHeight;
      mobileFontSize = theme.typography.fonts.sizes.md.size;
      mobileLineHeight = theme.typography.fonts.sizes.md.lineHeight;
      break;

    case "md":
      fontSize = theme.typography.fonts.sizes.md.size;
      fontLineHeight = theme.typography.fonts.sizes.md.lineHeight;
      mobileFontSize = theme.typography.fonts.sizes.sm.size;
      mobileLineHeight = theme.typography.fonts.sizes.sm.lineHeight;
      break;

    case "sm":
      fontSize = theme.typography.fonts.sizes.sm.size;
      fontLineHeight = theme.typography.fonts.sizes.sm.lineHeight;
      mobileFontSize = theme.typography.fonts.sizes.xs.size;
      mobileLineHeight = theme.typography.fonts.sizes.xs.lineHeight;
      break;

    case "xs":
      fontSize = theme.typography.fonts.sizes.xs.size;
      fontLineHeight = theme.typography.fonts.sizes.xs.lineHeight;
      mobileFontSize = fontSize;
      mobileLineHeight = fontLineHeight;
      break;

    default:
      fontSize = "inherit";
      fontLineHeight = "inherit";
      mobileFontSize = "inherit";
      mobileLineHeight = "inherit";
  }

  var Code = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tfont-size: ", ";\n\t\tline-height: ", ";\n\t\t@media only screen and (max-width: ", ") {\n\t\t\tfont-size: ", ";\n\t\t\tline-height: ", ";\n\t\t}\n\t"])), fontSize, fontLineHeight, theme.breakpoints.lg, mobileFontSize, mobileLineHeight);
  return (0, jsx_runtime_1.jsx)(Code, {
    className: className,
    "data-testid": dataTestId,
    children: (0, jsx_runtime_1.jsx)(react_syntax_highlighter_1.Prism, {
      customStyle: {
        fontSize: "inherit",
        lineHeight: "inherit",
        padding: "24px",
        border: "none",
        borderRadius: "4px",
        backgroundColor: backgroundColor
      },
      language: language,
      style: prism_1.vs,
      showLineNumbers: false,
      codeTagProps: {
        style: {
          fontSize: "inherit",
          lineHeight: "inherit"
        }
      },
      children: children
    })
  });
};

exports.Code = Code;